import { REHYDRATE } from "redux-persist/constants"

import {
    AUTHENTICATION_LOGIN_RESPONSE,
    AUTHENTICATION_TOKEN_RESPONSE,
    AUTHENTICATION_LOGIN_ERROR,
    AUTHENTICATION_LOGIN_UNAUTHORIZED,
    UNAUTHENTICATED,
    SET_HAS_BEEN_ACTIVE
} from "../actions/action-types"

const defaultState = {
    authenticated: false,
    permissions: []
}

export default (state = defaultState, action) => {
    const { type, error, payload, ...user } = action
    switch (type) {
        case REHYDRATE:
            const { authentication } = payload
            return {
                ...state,
                ...authentication
            }
        case SET_HAS_BEEN_ACTIVE:
            return {
                ...state,
                hasBeenActive: action.hasBeenActive
            }
        case AUTHENTICATION_TOKEN_RESPONSE:
        case AUTHENTICATION_LOGIN_RESPONSE:
            return {
                ...state,
                authenticated: true,
                ...user
            }
        case AUTHENTICATION_LOGIN_ERROR:
            return {
                authenticated: false
            }
        case AUTHENTICATION_LOGIN_UNAUTHORIZED:
            return {
                authenticated: false
            }
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
